/**
 * ADA / WCAG 2.1 AA Accessibility Utilities for Charm Theme
 * Handles tooltip cleanup, accessible names, image alt attributes, and hover dismissibility.
 */
document.addEventListener('DOMContentLoaded', () => {
  // 1. WCAG 1.4.13: Strip redundant browser-native title tooltips on links and buttons that already have accessible text
  const elementsWithTitle = document.querySelectorAll('a[title], button[title]');
  elementsWithTitle.forEach((el) => {
    const text = (el.innerText || el.textContent || '').trim();
    const ariaLabel = el.getAttribute('aria-label');
    if (text.length > 0 || (ariaLabel && ariaLabel.trim().length > 0)) {
      el.removeAttribute('title');
    }
  });

  // 2. WCAG 1.1.1: Ensure all images have an alt attribute
  const images = document.querySelectorAll('img:not([alt])');
  images.forEach((img) => {
    img.setAttribute('alt', img.getAttribute('title') || '');
  });

  // 3. WCAG 4.1.2: Ensure all links have an accessible name
  const links = document.querySelectorAll('a:not([aria-label])');
  links.forEach((link) => {
    const text = (link.innerText || link.textContent || '').trim();
    if (!text && !link.querySelector('img[alt]:not([alt=""])')) {
      const title = link.getAttribute('title');
      const href = link.getAttribute('href') || '';
      if (title && title.trim()) {
        link.setAttribute('aria-label', title.trim());
      } else if (href && href !== '#' && !href.startsWith('javascript:')) {
        try {
          const url = new URL(href, window.location.origin);
          link.setAttribute('aria-label', `Visit ${url.hostname.replace(/^www\./, '')}`);
        } catch (e) {
          link.setAttribute('aria-label', 'Learn more');
        }
      } else {
        link.setAttribute('aria-label', 'Learn more');
      }
    }
  });

  // 4. WCAG 1.4.13: Secondary hover images marked decorative & dismissible with Escape key
  document.querySelectorAll('.secondary-image').forEach((img) => {
    img.setAttribute('aria-hidden', 'true');
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' || e.key === 'Esc') {
      document.body.classList.add('hide-hover-content');
      setTimeout(() => {
        document.body.classList.remove('hide-hover-content');
      }, 800);
    }
  });

  // 5. WCAG 1.3.1: Heading structure safety check - Ensure at least one H1 exists on the page
  if (!document.querySelector('h1')) {
    const mainContent = document.getElementById('MainContent') || document.querySelector('main') || document.body;
    const h1 = document.createElement('h1');
    h1.className = 'visually-hidden';
    const rawTitle = (document.title || '').split('–')[0].split('|')[0].trim();
    h1.textContent = rawTitle || 'Rustic Strength';
    mainContent.prepend(h1);
  }

  // 6. WCAG 2.4.11 / 1.3.1: Mark closed app review modals inert and aria-hidden
  const reviewModals = document.querySelectorAll('.jdgm-write-review-modal, .jdgm-modal');
  reviewModals.forEach((modal) => {
    if (!modal.classList.contains('jdgm-modal--open') && !modal.classList.contains('jdgm--visible')) {
      modal.setAttribute('aria-hidden', 'true');
      modal.setAttribute('inert', '');
      modal.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach((h) => {
        h.setAttribute('aria-hidden', 'true');
      });
    }
  });
});
